import type { ContentRef, IntegrationsBlocksSet } from '@gitbook/api-client';
import type { MaybePromise } from '@gitbook/util-ts';

/**
 * Options for formatting content.
 */
export interface FormattingOptions {
    /**
     * Offset for headings since GitBook only supports h1/h2/h3, to indicate where to start.
     * Ex: with 1, BLOCK_HEADING_1 will generate an h2
     */
    headingsOffset?: number;

    /**
     * An optional function to transform text. If not specified, text is formatted
     * as-is.
     */
    textTransform?: (text: string) => string;

    /**
     * Resolve a content ref to an href. If it returns null, the link/mention is stripped.
     */
    resolveContentRef: (src: ContentRef) => MaybePromise<{ url: string; text: string } | null>;

    /**
     * Integration custom blocks to parse.
     */
    integrationBlocks?: IntegrationsBlocksSet;
}

export const defaultFormattingOptions: FormattingOptions = {
    resolveContentRef: async (ref) => {
        switch (ref.kind) {
            case 'url':
                return { url: ref.url, text: ref.url };
            default:
                return null;
        }
    },
};
